import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { AdvertisementsList } from "../../../components";
import CommonButton from "../../../components/common/button/Button";
import CommonContainer from "../../../components/common/container/CommonContainer";
import { Link } from "react-router-dom";

const ViewAdvertisements: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <CommonContainer title={t("adsListingPageTitle")} description={t("adsListingPageDescription")}>
      <Box className="w-full" display="flex" flexDirection="row-reverse" justifyContent="flex-start">
        <CommonButton
          {...{ component: Link, to: "/shopOwner/advertisements/create" }}
          variant='contained'
          color='primary'
          sx={{ width: "20%", height: "30px" }}
          endIcon={<Add />}
        >
          {t("createAd")}
        </CommonButton>
      </Box>
      <AdvertisementsList />
    </CommonContainer>);
};

export default ViewAdvertisements;
